import React, { useReducer, useEffect } from 'react'

import Button from 'react-bulma-components/lib/components/button'
import BNGMap from '../bngmap/BNGMap'
import Columns from 'react-bulma-components/lib/components/columns'
import Column from 'react-bulma-components/lib/components/columns/components/column'
import GeoJsonHover from '../bngmap/GeoJsonHover'
import merge from 'merge'
import Modal from 'react-bulma-components/lib/components/modal'
import ModalCard from 'react-bulma-components/lib/components/modal/components/card/card'
import ModalHead from 'react-bulma-components/lib/components/modal/components/card/head'
import ModalBody from 'react-bulma-components/lib/components/modal/components/card/body'
import ModalFoot from 'react-bulma-components/lib/components/modal/components/card/foot'
import ModalTitle from 'react-bulma-components/lib/components/modal/components/card/title'
import { WMSTileLayer } from 'react-leaflet'

const data = require('../../data/regions.json')

const urlBase = process.env.REACT_APP_API_PATH

const getData = async (onDataReturn) => {
  const euroregions = Object.assign({}, data)
  const eurofeatures = euroregions.features.filter(({ properties }) => {
    return properties.id !== 'eng'
  })
  euroregions.features = eurofeatures
  const names = euroregions.features.map(({ properties }) => ({ name: properties.name, id: properties.id }))
  onDataReturn({ euroregions, names })
}

const reducer = (state, action) => {
  const { type, payload } = action
  const update = {}

  if (type === 'reset') {
    update.loading = true
    update.data = data
    update.selected = ''
  }

  if (type === 'fetch') {
    update.loading = false
    update.names = payload.names
  }

  if (type === 'hover') {
    update.hovered = payload.name
  }

  if (type === 'out') {
    update.hovered = ''
  }

  if (type === 'click') {
    update.id = payload.id
    update.selected = payload.name
  }

  return merge.recursive(true, state, update)
}

const initalState = {
  loading: true,
  data: data,
  names: [],
  select: ''
}

export default ({ select, active, close, parent }) => {
  const [state, dispatch] = useReducer(reducer, initalState)

  useEffect(() => {
    if ('key' in parent && state.loading) {
      getData(({ euroregions, names }) => {
        dispatch({
          type: 'fetch',
          payload: { euroregions, names, features: data.features }
        })
      })
    } else if (state.loading) {
      dispatch({ type: 'reset', payload: {} })
    }
  }, [parent, state.loading])

  const closeModal = () => {
    dispatch({ type: 'reset', payload: {} })
    close()
  }

  return <Modal show={active} onClose={closeModal}>
    <ModalCard>
      <ModalHead onClose={closeModal}>
        <ModalTitle>{parent.label}</ModalTitle>
      </ModalHead>
      <ModalBody>
        <Columns>
          <Column size='two-thirds'>
            <BNGMap >
              <WMSTileLayer url={`${urlBase}/maps/mapserv?map=/background/land.map`} layers='land' format='image/png' transparent />
              <GeoJsonHover selected={state.selected} hovered={state.hovered} data={data} />
            </BNGMap>
          </Column>
          <Column size='one-third'>
            <ul className='modal-list options-buttons'>
              {state.names.length === 0
                ? <li><Button fullwidth loading /></li>
                : state.names.map(({ name, id }, index) => <li key={`${name}-${index}`}>
                  <Button
                    fullwidth
                    className={`is-${name === state.selected ? 'selected' : 'default'}`}
                    onMouseOver={() => { dispatch({ type: 'hover', payload: { name } }) }}
                    onMouseOut={() => { dispatch({ type: 'out', payload: {} }) }}
                    onClick={() => { dispatch({ type: 'click', payload: { name, id } }) }} >
                    {name}
                  </Button>
                </li>)
              }
            </ul>
          </Column>
        </Columns>
      </ModalBody>
      <ModalFoot>
        <div className='buttons modal-confirmation'>
          <Button onClick={closeModal}>CANCEL</Button>
          <Button
            disabled={state.selected === ''}
            color='primary'
            onClick={() => {
              closeModal()
              select({ id: state.id, label: state.selected, parent: parent.key })
            }}>OK</Button>
        </div>
      </ModalFoot>
    </ModalCard>
  </Modal>
}
